module.exports = __webpack_public_path__ + "img/header-weddingRingsRingSets@2x.c1b258b.jpg";